module.exports = __webpack_public_path__ + "img/instruction_fullorder_3d_mobile.636a4e2d.png";